// src/context/MapContext.js
import React, { createContext, useState, useEffect } from 'react';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';

// Create the context
export const MapContext = createContext();

// Create the provider component
export const MapProvider = ({ children }) => {
  const [map, setMap] = useState(null);

  // Initialize the map object on component mount
  useEffect(() => {
    const mapObject = new Map({
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: [0, 0], // EPSG:3857 coordinates
        zoom: 2,
      }),
    });

    setMap(mapObject); // Set the map object in state

    // Clean up on unmount
    return () => {
      mapObject.setTarget(null);
    };
  }, []);

  return (
    <MapContext.Provider value={{ map }}>
      {children}
    </MapContext.Provider>
  );
};
